import { Vector2 } from "three";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { isClassOf } from "../../../library-js/tools/TypeUtilities";
import { NodeGraph } from "../model/NodeGraph";
import { NodeGraphComponent } from "../model/NodeGraphComponent";
import { NodeGraphController } from "./NodeGraphController";
import { ElementWithNodeGraphReference, NodeGraphEvent } from "./NodeGraphEvent";
import { NodeGraphInteraction } from "./NodeGraphInteraction";

export class NGEdgeCreator extends NodeGraphInteraction
{
  _startingComponent:NodeGraphComponent;
  _startingConnector:HTMLElement;
  _controller:NodeGraphController;
  
  constructor( ng:NodeGraph )
  {
    super( ng );
    this._controller = this._nodeGraph._controller;
  }

  get edgeCreationLayer()
  {
    return this._nodeGraph._ui._overlaysLayer;
  }

  start( component: NodeGraphComponent, connector:HTMLElement )
  {
    this._startingComponent = component;
    this._startingConnector = connector;

    this.edgeCreationLayer.edgeCreation.value = true;
  }

  _createConnection( hoveredReference:ElementWithNodeGraphReference )
  {
    let startIsInput = NodeGraphComponent.inputConnector.is( this._startingConnector );
    let endIsInput   = NodeGraphComponent.inputConnector.is( hoveredReference.element );

    if ( startIsInput === endIsInput )
    {
      return;
    }

    let from = startIsInput ? hoveredReference.reference : this._startingComponent;
    let to   = startIsInput ? this._startingComponent    : hoveredReference.reference;

    this._nodeGraph._addEdge( from as NodeGraphComponent, to as NodeGraphComponent );
    this._nodeGraph._ui.updateEdges();
  }

  update( nge:NodeGraphEvent )
  {
    if ( ! this._controller.isFocused( this ) )
    {
      if ( nge.mouse.buttons[ 0 ].isDown )
      {
        let hovered = nge.hoveredReference;

        if ( ! hovered ) 
        {
          return;
        }

        if ( isClassOf( hovered.reference, NodeGraphComponent ) )
        {
          let isConnector = NodeGraphComponent.inputConnector.is( hovered.element ) ||
                            NodeGraphComponent.outputConnector.is( hovered.element ) ;

          if ( isConnector )
          {
            this.start( hovered.reference as NodeGraphComponent, hovered.element as HTMLElement );
            this._controller.focus( this );
            this._udpatePositions( nge );
            this.edgeCreationLayer.redraw();     
          }
          
        }

        return;
      }

      return;
    }

    if ( nge.mouse.buttons[ 0 ].isDown )
    {
      let hovered = nge.hoveredReference;

      if ( hovered && isClassOf( hovered.reference, NodeGraphComponent ) )
      {
        let isConnector = NodeGraphComponent.inputConnector.is( hovered.element ) ||
                          NodeGraphComponent.outputConnector.is( hovered.element ) ;

        if ( isConnector )
        {
          this._createConnection( hovered );
        }
      }

      this._finishCreation();

      return;
    }
        

    this._udpatePositions( nge );
    this.edgeCreationLayer.redraw();

  }

  _udpatePositions( nge:NodeGraphEvent )
  {
    DOMHitTest.getPageBox( this._startingConnector ).getCenter( this.edgeCreationLayer.edgeCreationStart.value ).sub( nge.pageOffset );
    this.edgeCreationLayer.edgeCreationEnd.value.copy( nge.mouse.position ).sub( nge.pageOffset );  
  }

  _finishCreation()
  {
    this._controller.blur();

    this._startingComponent = null;
    this._startingConnector = null;

    this.edgeCreationLayer.edgeCreation.value = false;
    this.edgeCreationLayer.redraw();
  }
}